import { CheckboxDesignTokens } from '@primeuix/themes/types/checkbox';

export const checkboxPreset: CheckboxDesignTokens = {
  root: {},
  icon: {
    color: '{nspSlate.0}',
    checkedColor: '{nspSlate.0}',
  },
  colorScheme: {
    dark: {
      root: {
        background: 'transparent',
        borderColor: '{nspSlate.200}',
        hoverBorderColor: '{nspSlate.200}',
        checkedHoverBackground: '{nspSlate.400}',
        checkedHoverBorderColor: '{nspSlate.400}',
        focusBorderColor: '{nspSky.300}',
        disabledBackground: 'transparent',
        checkedDisabledBorderColor: '{nspSlate.400}',
      },
    },
    light: {
      root: {
        background: 'transparent',
        borderColor: '{nspSlate.200}',
        hoverBorderColor: '{nspSlate.200}',
        checkedHoverBackground: '{nspSlate.400}',
        checkedHoverBorderColor: '{nspSlate.400}',
        focusBorderColor: '{nspSky.300}',
        disabledBackground: 'transparent',
        checkedDisabledBorderColor: '{nspSlate.400}',
      },
    },
  },
  css: ({ dt }) => `
  /* Indeterminate, default */
  .p-checkbox:not(.p-disabled):not(.p-invalid):not(.p-checkbox-checked) .p-checkbox-box:has(.p-checkbox-icon) {
    border-color: ${dt('checkbox.checked.background')};
  }

  /* Indeterminate, invalid */
  .p-checkbox:not(.p-disabled):not(.p-checkbox-checked) .p-checkbox-box:has(.p-checkbox-icon) {
    background: ${dt('checkbox.checked.background')};
  }

  /* Indeterminate, hover */
  .p-checkbox:not(.p-disabled):not(.p-invalid):not(.p-checkbox-checked):hover .p-checkbox-box:has(.p-checkbox-icon) {
    border-color: ${dt('checkbox.checked.hoverBorderColor')};
    background: ${dt('checkbox.checked.hoverBackground')};
  }

  /* Indeterminate/checked, disabled */
  .p-checkbox.p-disabled .p-checkbox-box:has(.p-checkbox-icon) {
    border-color: ${dt('nspOcean.700')};
    background: ${dt('nspOcean.700')};
  }
  `,
};
